import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyC49V_XryBuaZQfwlMXKXik5Hyx1e9qbhU",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "parkingapp-501015.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "parkingapp-501015",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "parkingapp-501015.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "567815961712",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:567815961712:web:f25437c80dac45b93808b5",
  measurementId: "G-3XZKPZ0W72"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
